import type { AutocompleteIndex } from '@algolia-search/types';
import type { SearchResults } from 'algoliasearch-helper';

export const getResultsFromIndex = <T extends { objectID: string }>(
  indices: AutocompleteIndex<T>[],
  indexName: string
): SearchResults<T> | undefined => {
  return indices.find((i) => i.indexName === indexName)?.results;
};
